import VNavItem from './VNavItem.vue';

export { VNavItem };
export default VNavItem;
